import Vue from 'vue'
import Router from 'vue-router'
import VuePageTransition from 'vue-page-transition'
import Top from '@/pages/Top'
import Home from '@/pages/Home'
import Selectsong from '@/pages/Selectsong'
import Selectedsong from '@/pages/Selectedsong'
import Gameplay from '@/pages/Gameplay'
import History from '@/pages/History'
import fullscreen from 'vue-fullscreen'

Vue.use(Router)
Vue.use(VuePageTransition)
Vue.use(fullscreen)

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Top",
      component: Top
    },
    {
      path: "/home",
      name: "Home",
      component: Home
    },
    {
      path: "/Selectsong",
      name: "Selectsong",
      component: Selectsong
    },
    {
      path: "/Selectedsong",
      name: "Selectedsong",
      component: Selectedsong
    },
    {
      path: "/Gameplay",
      name: "Gameplay",
      component: Gameplay
    },
    {
      path: "/History",
      name: "History",
      component: History
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js